var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledgeAnimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-webinar:not(.animated) .animable {opacity: 0;}svg#freepik_stories-webinar.animated #freepik--background-complete--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-webinar.animated #freepik--Table--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-webinar.animated #freepik--Plants--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-webinar.animated #freepik--Device--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-webinar.animated #freepik--Character--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-webinar.animated #freepik--speech-bubble--inject-46 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight,1.5s Infinite  linear heartbeat;animation-delay: 0s,1s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "378.585px 245.945px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m585.65 202.63h142.49l-23.21 16.75v33a6.88 6.88 0 0 1-6.88 6.88h-112.4a6.88 6.88 0 0 1-6.88-6.88v-42.87a6.88 6.88 0 0 1 6.88-6.88z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "653.455px 230.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m591.59 225.92c0 0.14 21.49 0.25 48 0.25s48-0.11 48-0.25-21.49-0.25-48-0.25-48 0.11-48 0.25z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "639.59px 225.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m591.59 238.57c0 0.14 21.49 0.25 48 0.25s48-0.11 48-0.25-21.49-0.25-48-0.25-48 0.12-48 0.25z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "639.59px 238.57px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 362.57,
    y: 81.03,
    width: 6.67,
    height: 22.34,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "365.905px 92.2px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 306.87,
    y: 77.8,
    width: 6.67,
    height: 25.57,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "310.205px 90.585px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.8,
    y: 72.47,
    width: 6.67,
    height: 30.9,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "324.135px 87.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 334.72,
    y: 74.16,
    width: 6.67,
    height: 29.21,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "338.055px 88.765px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 348.64,
    y: 64.28,
    width: 6.67,
    height: 39.09,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "351.975px 83.825px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 376.49,
    y: 64.47,
    width: 6.67,
    height: 38.9,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "379.825px 83.92px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 390.42,
    y: 77.25,
    width: 6.67,
    height: 26.12,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "393.755px 90.31px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 404.34,
    y: 66.18,
    width: 6.67,
    height: 37.19,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "407.675px 84.775px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 418.27,
    y: 57.81,
    width: 6.67,
    height: 45.56,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "421.605px 80.59px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 432.19,
    y: 65.99,
    width: 6.67,
    height: 37.38,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "435.525px 84.68px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m614.56 101.3 55.14-8.43a55.8 55.8 0 1 1-49-47z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "614.545px 101.329px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m632.45 46-6.69 42.74 42-7.88s-6.21-23.92-35.31-34.86z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "646.76px 67.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M51.48,205a27.34,27.34,0,1,1,27.78,27A27.44,27.44,0,0,1,51.48,205Zm40.41-.66A13.07,13.07,0,1,0,79,217.69,13.11,13.11,0,0,0,91.89,204.34Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "78.8179px 204.663px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M51.48,205a27.44,27.44,0,0,1,26.9-27.91l.23,14.33A13.14,13.14,0,0,0,79,217.69L79.26,232A27.43,27.43,0,0,1,51.48,205Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "65.3679px 204.546px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M75.93,174.88a31.26,31.26,0,0,1,32,31.13l-16.7.26c-.13-8.47-6.58-13.8-15-13.66Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "91.93px 190.571px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 194.36,
    y: 301.44,
    width: 34.76,
    height: 41.32,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "211.74px 322.1px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 38.5,
    y: 298.74,
    width: 157.07,
    height: 46.61,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "117.035px 322.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m230.17 302.66h-38.82v-3.92h38.82a2 2 0 0 1 2 2 2 2 0 0 1-2 1.92z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.76px 300.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m230.17 345.35h-38.82v-3.92h38.82a2 2 0 0 1 2 2 2 2 0 0 1-2 1.92z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.76px 343.39px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 164.66,
    y: 298.74,
    width: 18.56,
    height: 46.61,
    fill: "#ebebeb",
    style: {
      transformOrigin: "173.94px 322.045px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 53.43,
    y: 299.26,
    width: 18.56,
    height: 46.61,
    fill: "#ebebeb",
    style: {
      transformOrigin: "62.71px 322.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.12 308.27c0 0.12-7.52 0.21-16.8 0.21s-16.8-0.09-16.8-0.21 7.52-0.21 16.8-0.21 16.8 0.1 16.8 0.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "212.32px 308.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M229.12,314.47c0,.11-7.52.2-16.8.2s-16.8-.09-16.8-.2,7.52-.21,16.8-.21S229.12,314.35,229.12,314.47Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "212.32px 314.465px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M229.12,322.1c0,.11-7.52.2-16.8.2s-16.8-.09-16.8-.2,7.52-.21,16.8-.21S229.12,322,229.12,322.1Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "212.32px 322.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.12 329.72c0 0.12-7.52 0.21-16.8 0.21s-16.8-0.09-16.8-0.21 7.52-0.2 16.8-0.2 16.8 0.09 16.8 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "212.32px 329.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.12 337.35c0 0.12-7.52 0.21-16.8 0.21s-16.8-0.09-16.8-0.21 7.52-0.2 16.8-0.2 16.8 0.09 16.8 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "212.32px 337.355px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 84.02,
    y: 317.9,
    width: 70.66,
    height: 8.39,
    fill: "#ebebeb",
    style: {
      transformOrigin: "119.35px 322.095px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 193.48,
    y: 346.27,
    width: 35.29,
    height: 25.18,
    fill: "#fafafa",
    style: {
      transformOrigin: "211.125px 358.86px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 43.7,
    y: 345.35,
    width: 150.18,
    height: 27,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.79px 358.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M192.78,347.18h37.93a.91.91,0,0,0,.91-.91h0a.92.92,0,0,0-.91-.92H192.78Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "212.2px 346.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m192.78 370.53h38.42a0.42 0.42 0 0 1 0.42 0.42v1a0.42 0.42 0 0 1-0.42 0.42h-38.42v-1.83a0 0 0 0 1 0-0.01z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "212.2px 371.45px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M228.77,351.05c0,.11-7.82.21-17.45.21s-17.45-.1-17.45-.21,7.81-.21,17.45-.21S228.77,350.94,228.77,351.05Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.32px 351.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M228.77,355.81c0,.12-7.82.21-17.45.21s-17.45-.09-17.45-.21,7.81-.2,17.45-.2S228.77,355.7,228.77,355.81Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.32px 355.815px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M228.77,360.58c0,.11-7.82.2-17.45.2s-17.45-.09-17.45-.2,7.81-.21,17.45-.21S228.77,360.46,228.77,360.58Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.32px 360.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M228.77,365.34c0,.11-7.82.2-17.45.2s-17.45-.09-17.45-.2,7.81-.21,17.45-.21S228.77,365.22,228.77,365.34Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "211.32px 365.335px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 198.1,
    y: 374.76,
    width: 36.02,
    height: 68.25,
    fill: "#ebebeb",
    style: {
      transformOrigin: "216.11px 408.885px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 29.03,
    y: 372.36,
    width: 169.07,
    height: 74,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "113.565px 409.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m236.94 446.35h-43.46v-4.8h43.46a2.41 2.41 0 0 1 2.4 2.4 2.4 2.4 0 0 1-2.4 2.4z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.41px 443.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m193.48 372.36h44.76a1.1 1.1 0 0 1 1.1 1.1v2.6a1.1 1.1 0 0 1-1.1 1.1h-44.76v-4.8z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.41px 374.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 383.9c0 0.12-8.06 0.21-18 0.21s-18-0.09-18-0.21 8.06-0.2 18-0.2 18 0.09 18 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 383.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 392.66c0 0.11-8.06 0.2-18 0.2s-18-0.09-18-0.2 8.06-0.21 18-0.21 18 0.09 18 0.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 392.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 401.41c0 0.11-8.06 0.21-18 0.21s-18-0.1-18-0.21 8.06-0.21 18-0.21 18 0.1 18 0.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 401.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 410.16c0 0.12-8.06 0.21-18 0.21s-18-0.09-18-0.21 8.06-0.2 18-0.2 18 0.09 18 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 410.165px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 418.92c0 0.11-8.06 0.2-18 0.2s-18-0.09-18-0.2 8.06-0.21 18-0.21 18 0.09 18 0.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 418.915px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 427.67c0 0.11-8.06 0.21-18 0.21s-18-0.1-18-0.21 8.06-0.21 18-0.21 18 0.1 18 0.21z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 427.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.12 436.42c0 0.12-8.06 0.21-18 0.21s-18-0.09-18-0.21 8.06-0.2 18-0.2 18 0.09 18 0.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "216.12px 436.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M86.88,413.4v4.12c0,5-2.48,7.79-7.26,7.79s-7.26-2.83-7.26-7.79V401.41c0-5,2.48-7.8,7.26-7.8s7.26,2.84,7.26,7.8v3h-4.6V401.1c0-2.22-1-3.06-2.52-3.06s-2.53.84-2.53,3.06v16.73c0,2.22,1,3,2.53,3s2.52-.79,2.52-3V413.4Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "79.62px 409.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.45,401.41c0-5,2.61-7.8,7.39-7.8s7.39,2.84,7.39,7.8v16.11c0,5-2.61,7.79-7.39,7.79s-7.39-2.83-7.39-7.79Zm4.87,16.42c0,2.22,1,3.06,2.52,3.06s2.52-.84,2.52-3.06V401.1c0-2.22-1-3.06-2.52-3.06s-2.52.84-2.52,3.06Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "96.84px 409.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.37,394h4.87v26.56h8V425H107.37Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "113.805px 409.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M122,401.41c0-5,2.61-7.8,7.39-7.8s7.4,2.84,7.4,7.8v16.11c0,5-2.61,7.79-7.4,7.79s-7.39-2.83-7.39-7.79Zm4.87,16.42c0,2.22,1,3.06,2.52,3.06s2.53-.84,2.53-3.06V401.1c0-2.22-1-3.06-2.53-3.06s-2.52.84-2.52,3.06Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "129.395px 409.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M144.56,394v23.91c0,2.21,1,3,2.52,3s2.52-.8,2.52-3V394h4.61v23.6c0,4.95-2.48,7.79-7.26,7.79s-7.26-2.84-7.26-7.79V394Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "146.95px 409.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M167.71,425a9.39,9.39,0,0,1-.45-3.81v-4.87c0-2.88-1-3.94-3.18-3.94h-1.69V425h-4.87V394h7.35c5,0,7.22,2.35,7.22,7.13v2.43c0,3.19-1,5.27-3.19,6.29,2.44,1,3.23,3.36,3.23,6.59v4.79a9.07,9.07,0,0,0,.54,3.76Zm-5.32-26.56v9.51h1.91c1.81,0,2.92-.79,2.92-3.27v-3.06c0-2.21-.75-3.18-2.48-3.18Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "165.095px 409.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.83,356H82.28l.19-.92h8.15l-.2.92H86.88l-1.83,9.14H84Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "86.45px 360.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.46,357.57l-5.52,8.54C91,367.55,90.3,368,89.21,368a2.45,2.45,0,0,1-1.8-.67l.54-.75a1.81,1.81,0,0,0,1.34.55c.65,0,1.15-.31,1.74-1.23l.53-.8-1.88-7.52h1L92.28,364l4.13-6.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "92.435px 362.781px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m105.86 360.7a4.26 4.26 0 0 1-4.28 4.5 2.84 2.84 0 0 1-2.88-1.65l-0.86 4.37h-1l2.06-10.35h1l-0.24 1.21a3.82 3.82 0 0 1 3-1.27 3.05 3.05 0 0 1 3.2 3.19zm-1 0.06a2.22 2.22 0 0 0-2.49-2.36 3.3 3.3 0 0 0-3.29 3.6 2.2 2.2 0 0 0 2.49 2.35 3.3 3.3 0 0 0 3.26-3.59z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "101.353px 362.713px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m107.05 362a4.29 4.29 0 0 1 4.37-4.49c2.1 0 3.44 1.24 3.44 3.19a4.3 4.3 0 0 1-4.37 4.5 3.11 3.11 0 0 1-3.44-3.2zm6.79-1.24a2.22 2.22 0 0 0-2.49-2.36 3.33 3.33 0 0 0-3.28 3.55 2.21 2.21 0 0 0 2.49 2.35 3.31 3.31 0 0 0 3.28-3.54z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "110.955px 361.363px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.64,357.57l-1.32,6.64c-.53,2.68-1.94,3.78-4.4,3.78a4.82,4.82,0,0,1-3.36-1.13l.6-.78a4,4,0,0,0,2.84,1,3,3,0,0,0,3.27-2.71l.18-.83a3.9,3.9,0,0,1-3,1.29c-2,0-3.34-1.16-3.34-3a4.18,4.18,0,0,1,4.31-4.29,2.9,2.9,0,0,1,2.95,1.73l.32-1.67Zm-1.72,3c0-1.38-.93-2.2-2.5-2.2a3.21,3.21,0,0,0-3.29,3.34c0,1.38.92,2.2,2.5,2.2A3.21,3.21,0,0,0,122.92,360.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "120.1px 362.761px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.31,357.51l-.19,1h-.28c-1.61,0-2.69.92-3.07,2.8l-.76,3.84h-1l1.5-7.56h1L128.2,359A3.43,3.43,0,0,1,131.31,357.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "128.66px 361.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m140 357.57-1.51 7.56h-1l0.24-1.19a3.85 3.85 0 0 1-2.94 1.26 3.05 3.05 0 0 1-3.3-3.2 4.26 4.26 0 0 1 4.27-4.49 2.84 2.84 0 0 1 2.88 1.64l0.32-1.58zm-1.7 3.19a2.22 2.22 0 0 0-2.49-2.36 3.32 3.32 0 0 0-3.27 3.55 2.2 2.2 0 0 0 2.46 2.35 3.31 3.31 0 0 0 3.28-3.54z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "135.742px 361.352px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.79 360.7a4.26 4.26 0 0 1-4.28 4.5 2.84 2.84 0 0 1-2.88-1.65l-0.86 4.37h-1l2.05-10.35h1l-0.24 1.21a3.8 3.8 0 0 1 2.94-1.27 3.06 3.06 0 0 1 3.27 3.19zm-1 0.06a2.22 2.22 0 0 0-2.49-2.36 3.3 3.3 0 0 0-3.3 3.6 2.2 2.2 0 0 0 2.48 2.35 3.3 3.3 0 0 0 3.28-3.59z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "145.283px 362.711px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M158.94,360a4.37,4.37,0,0,1-.08.86l-.86,4.3h-1l.87-4.31a4.48,4.48,0,0,0,.07-.69c0-1.08-.65-1.7-2-1.7a2.94,2.94,0,0,0-3.07,2.65l-.81,4.05h-1l2.13-10.67h1l-.85,4.24a3.72,3.72,0,0,1,2.89-1.19C158,357.51,158.94,358.43,158.94,360Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "155px 359.825px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M168.5,357.57,163,366.11c-.94,1.44-1.64,1.88-2.73,1.88a2.45,2.45,0,0,1-1.8-.67l.55-.75a1.77,1.77,0,0,0,1.33.55c.65,0,1.15-.31,1.74-1.23l.54-.8-1.89-7.52h1l1.56,6.44,4.13-6.44Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "163.485px 362.781px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M191.28,46.79H37.89l25,18v35.47a7.4,7.4,0,0,0,7.41,7.41h121a7.41,7.41,0,0,0,7.41-7.41V54.2A7.41,7.41,0,0,0,191.28,46.79Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "118.3px 77.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M184.88,71.86c0,.15-23.13.27-51.66.27S81.55,72,81.55,71.86s23.13-.27,51.67-.27S184.88,71.71,184.88,71.86Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "133.215px 71.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M184.88,85.48c0,.15-23.13.27-51.66.27s-51.67-.12-51.67-.27,23.13-.27,51.67-.27S184.88,85.33,184.88,85.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "133.215px 85.48px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "373px 446.35px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M723.27,446.35c0,.15-156.84.26-350.25.26s-350.29-.11-350.29-.26,156.8-.26,350.29-.26S723.27,446.21,723.27,446.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "373px 446.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "384.239px 361.793px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m657.45 395.31s-26.51-30.5-36.51-61-5.25-27-5.25-27 13.5 29.64 23.75 43.95 28.56 35.3 28.56 35.3z",
    fill: "#455a64",
    style: {
      transformOrigin: "641.281px 351.249px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m662.73 312a1.54 1.54 0 0 0-2.87 1c1.61 10.72 5.11 35.87 5 52.18-0.18 21.19 0 29.38 0 29.38h11s-2-43.8-4.45-57.16c-1.74-9.34-5.41-19.74-8.68-25.4z",
    fill: "#455a64",
    style: {
      transformOrigin: "667.849px 352.878px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M668.75,391a117,117,0,0,0,9.08-32.94c.91-7.8-.72-18.34-3.13-32.41a87.72,87.72,0,0,1-1.39-15.59,2.63,2.63,0,0,1,4.94-1.24c1.33,2.38,5.19,10.5,6.17,15.58,2.67,13.89,5.69,20.84,3.38,34s-10.86,33.48-10.86,33.48Z",
    fill: "#455a64",
    style: {
      transformOrigin: "678.686px 349.664px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m678.68 391.91s29.11-62.55 31.13-71.83 8.87-30.66 9.68-29.45 2 12.51-3.23 25.42-27.64 77.76-27.64 77.76h-9.94",
    fill: "#455a64",
    style: {
      transformOrigin: "699.445px 342.195px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M665.56,389.11a6.71,6.71,0,0,1-.82-.56c-.51-.39-1.3-.94-2.25-1.72a100.71,100.71,0,0,1-7.82-6.91,131,131,0,0,1-21.12-27.1,177.11,177.11,0,0,1-14.41-31.22c-1.46-4.15-2.53-7.55-3.22-9.92-.36-1.17-.61-2.1-.78-2.72a5.23,5.23,0,0,1-.22-1,6.23,6.23,0,0,1,.34.93l.89,2.69c.76,2.34,1.89,5.72,3.4,9.84a189.55,189.55,0,0,0,14.54,31.06A136.51,136.51,0,0,0,655,379.61c3.11,3.1,5.78,5.45,7.66,7,.93.81,1.69,1.39,2.18,1.81A6.1,6.1,0,0,1,665.56,389.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "640.24px 348.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M668.74,359.1a11.17,11.17,0,0,1-.26-1.83c-.14-1.3-.32-3-.53-5-.46-4.24-1.18-10.07-2.21-16.48s-2.18-12.18-3.07-16.34c-.43-2-.79-3.66-1.06-4.93a11.16,11.16,0,0,1-.33-1.83,10.67,10.67,0,0,1,.56,1.77c.33,1.15.76,2.82,1.26,4.89,1,4.14,2.22,9.91,3.25,16.34s1.68,12.28,2,16.53c.18,2.13.29,3.85.34,5A9,9,0,0,1,668.74,359.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "665.024px 335.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M675.56,308.35a4.66,4.66,0,0,1,.34.8c.23.59.52,1.36.88,2.32s.82,2.25,1.25,3.73,1,3.12,1.41,5l.72,2.94c.25,1,.42,2.11.64,3.22.48,2.22.77,4.63,1.12,7.16a106.64,106.64,0,0,1-1.18,33.06c-.53,2.5-1,4.88-1.63,7.06-.3,1.09-.55,2.16-.87,3.16s-.63,2-.93,2.89c-.56,1.85-1.23,3.46-1.77,4.89s-1.06,2.65-1.51,3.63l-1,2.25a4.32,4.32,0,0,1-.4.77,4.43,4.43,0,0,1,.29-.82l.92-2.3c.42-1,.92-2.21,1.41-3.65s1.15-3.06,1.68-4.91c.28-.92.58-1.88.89-2.88s.54-2.07.83-3.16c.61-2.18,1-4.55,1.57-7a110.65,110.65,0,0,0,1.18-32.89c-.34-2.52-.61-4.92-1.06-7.13-.22-1.11-.38-2.19-.61-3.21s-.46-2-.68-2.94c-.39-1.88-.92-3.54-1.32-5s-.79-2.72-1.14-3.74-.57-1.76-.76-2.36A4.49,4.49,0,0,1,675.56,308.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "677.659px 349.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M719.15,291.89a.75.75,0,0,1,0,.28c0,.22-.08.49-.13.81-.13.71-.29,1.77-.57,3.12-.56,2.69-1.5,6.56-3,11.26s-3.43,10.2-5.79,16.26-5.08,12.65-7.66,19.67-4.65,13.86-6.55,20.06-3.66,11.8-5.39,16.4a105.66,105.66,0,0,1-4.59,10.7c-.6,1.24-1.14,2.16-1.48,2.8l-.41.71a1,1,0,0,1-.16.24,1.12,1.12,0,0,1,.1-.27l.36-.74c.31-.66.81-1.6,1.37-2.85,1.17-2.48,2.75-6.12,4.4-10.74s3.4-10.19,5.26-16.41,3.87-13.08,6.5-20.11,5.34-13.63,7.72-19.67,4.41-11.52,5.9-16.19,2.51-8.51,3.14-11.18c.32-1.33.52-2.38.69-3.08.08-.32.14-.58.19-.8A.91.91,0,0,1,719.15,291.89Z",
    fill: "#263238",
    style: {
      transformOrigin: "701.292px 343.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m629.41 278.07a2.51 2.51 0 0 0-4.13 2.56 71.22 71.22 0 0 0 3.66 9.4c4 8.51 15.76 39 21.26 55.77s13.25 48 13.25 48l11.75-1.9s-10.75-51.35-21.2-69.9c-8.49-14.83-16.93-36.31-24.59-43.93z",
    fill: "#455a64",
    style: {
      transformOrigin: "650.184px 335.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M653.41,356.28a6.84,6.84,0,0,1,.61,1.41c.35.92.82,2.26,1.35,3.94,1.08,3.35,2.41,8,3.74,13.23s2.44,9.94,3.21,13.37c.36,1.62.65,3,.89,4.07a7.84,7.84,0,0,1,.24,1.51,7.18,7.18,0,0,1-.48-1.45c-.28-1.07-.64-2.42-1.07-4L658.51,375c-1.33-5.2-2.59-9.89-3.56-13.26l-1.16-4A7.63,7.63,0,0,1,653.41,356.28Z",
    fill: "#263238",
    style: {
      transformOrigin: "658.43px 375.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M669.35,392.86a1.41,1.41,0,0,1-.06-.31c0-.25-.08-.55-.14-.93-.12-.81-.23-2-.48-3.56-.43-3.08-1.2-7.53-2.46-12.95a187.84,187.84,0,0,0-5.5-18.77c-2.41-7-5.43-14.48-8.86-22.27-6.91-15.55-13.81-29.34-18.35-39.53-2.29-5.09-4.07-9.24-5.24-12.14-.6-1.44-1-2.57-1.32-3.34-.13-.36-.24-.64-.33-.88a1.13,1.13,0,0,1-.09-.3s.06.09.15.28.23.51.39.85l1.42,3.3c1.24,2.86,3.08,7,5.42,12,4.63,10.15,11.6,23.9,18.52,39.47,3.43,7.8,6.44,15.34,8.83,22.33A178.87,178.87,0,0,1,666.64,375a131.7,131.7,0,0,1,2.27,13c.21,1.55.28,2.76.37,3.58,0,.38.05.68.07.93A1.3,1.3,0,0,1,669.35,392.86Z",
    fill: "#263238",
    style: {
      transformOrigin: "647.941px 335.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M675.2,391.91a13.63,13.63,0,0,1-.4-2c-.23-1.38-.54-3.2-.91-5.4-.81-4.55-2-10.82-3.82-17.64s-3.75-12.91-5.27-17.27L663,344.46a11.9,11.9,0,0,1-.62-1.92,13.23,13.23,0,0,1,.85,1.83c.5,1.19,1.21,2.93,2,5.1a170.1,170.1,0,0,1,5.46,17.26,180.26,180.26,0,0,1,3.65,17.73c.34,2.29.59,4.15.72,5.44A13.42,13.42,0,0,1,675.2,391.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "668.79px 367.225px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 653.45,
    y: 390.22,
    width: 45.86,
    height: 55.87,
    fill: "#ff725e",
    style: {
      transformOrigin: "676.38px 418.155px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "676.38px 418.155px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 653.45,
    y: 390.22,
    width: 45.86,
    height: 55.87,
    style: {
      transformOrigin: "676.38px 418.155px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 644,
    y: 390.22,
    width: 40.68,
    height: 55.87,
    fill: "#ff725e",
    style: {
      transformOrigin: "664.34px 418.155px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m88.53 370.8c-7.82-5-18.64-5.1-26.24 0.21-7.22 5.05-10.89 14.23-10.57 23s4.59 19.55 12.56 24.18l23.4-0.1a31.42 31.42 0 0 0 12.88-23.61c0.35-9.24-4.22-18.68-12.03-23.68z",
    fill: "#455a64",
    style: {
      transformOrigin: "76.1397px 392.614px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M77,419.07a10.56,10.56,0,0,1-.14-2c0-1.44-.1-3.28-.16-5.49-.12-4.63-.3-11-.61-18.09s-.69-13.46-1-18.09c-.13-2.2-.24-4-.33-5.48a10.42,10.42,0,0,1,0-2,11.09,11.09,0,0,1,.32,2c.16,1.29.35,3.16.57,5.47.42,4.62.88,11,1.2,18.09s.41,13.49.39,18.13c0,2.32,0,4.19-.08,5.49A11,11,0,0,1,77,419.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "75.9773px 393.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M54.08,392.05c0,.2-1.29.27-2.84.14s-2.79-.4-2.78-.6,1.29-.27,2.84-.15S54.1,391.84,54.08,392.05Z",
    fill: "#263238",
    style: {
      transformOrigin: "51.2701px 391.819px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M54.52,384.15c-.09.19-1.18-.11-2.45-.68s-2.23-1.17-2.15-1.36,1.18.12,2.45.68S54.6,384,54.52,384.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "52.22px 383.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m58.58 378.29c-0.11 0.17-1.34-0.41-2.62-1.47s-2.09-2.17-1.94-2.3 1.17 0.69 2.41 1.72 2.26 1.87 2.15 2.05z",
    fill: "#263238",
    style: {
      transformOrigin: "56.2952px 376.413px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M62.67,372.76c-.19.08-.78-.84-1.32-2.06s-.83-2.28-.64-2.37.78.84,1.32,2.07S62.85,372.68,62.67,372.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "61.688px 370.544px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.08,368.84c-.19.08-.82-.9-1.25-2.26s-.46-2.54-.26-2.57.57,1,1,2.34S69.27,368.75,69.08,368.84Z",
    fill: "#263238",
    style: {
      transformOrigin: "68.2964px 366.427px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M79.77,364.41c.2.07.08.91-.26,1.88s-.78,1.69-1,1.62-.08-.9.26-1.87S79.58,364.34,79.77,364.41Z",
    fill: "#263238",
    style: {
      transformOrigin: "79.1355px 366.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m87.71 367.82c0.14 0.15-0.37 0.85-1.14 1.56s-1.5 1.16-1.64 1 0.37-0.85 1.13-1.56 1.51-1.15 1.65-1z",
    fill: "#263238",
    style: {
      transformOrigin: "86.32px 369.102px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M94.69,372.33c.12.17-.5.79-1.38,1.39s-1.69.94-1.81.77.51-.79,1.39-1.39S94.58,372.16,94.69,372.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "93.0951px 373.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.65,379.05c.08.19-.89.79-2.18,1.34s-2.4.84-2.48.65.9-.79,2.19-1.33S99.57,378.86,99.65,379.05Z",
    fill: "#263238",
    style: {
      transformOrigin: "97.32px 380.046px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.61,386.39c0,.2-1,.5-2.23.65s-2.28.12-2.31-.09,1-.49,2.22-.65S101.58,386.18,101.61,386.39Z",
    fill: "#263238",
    style: {
      transformOrigin: "99.3397px 386.668px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.62,395.42c-.08.19-1.14-.09-2.36-.62s-2.16-1.12-2.08-1.31,1.15.09,2.37.62S102.71,395.23,102.62,395.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "100.401px 394.455px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M101.73,403.17c-.07.19-1.41-.13-2.81-1.05s-2.23-2-2.09-2.15,1.17.66,2.5,1.52S101.8,403,101.73,403.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "99.2739px 401.587px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m97.69 410.22c-0.12 0.16-1.19-0.46-2.21-1.57s-1.57-2.21-1.41-2.33 1 0.77 2 1.82 1.76 1.92 1.62 2.08z",
    fill: "#263238",
    style: {
      transformOrigin: "95.8746px 408.277px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m59.39 411.05c0.09 0.18-1 1-2.51 1.72s-2.75 1.23-2.88 1.07 1-1 2.5-1.73 2.79-1.24 2.89-1.06z",
    fill: "#263238",
    style: {
      transformOrigin: "56.6925px 412.442px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M55.89,404.67c.08.19-.82.78-2,1.32s-2.23.83-2.32.64.82-.78,2-1.32S55.8,404.48,55.89,404.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "53.7294px 405.65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M53.32,399c0,.2-1.08.53-2.48.73s-2.54.19-2.57,0,1.08-.53,2.47-.72S53.29,398.81,53.32,399Z",
    fill: "#263238",
    style: {
      transformOrigin: "50.7947px 399.369px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M61.75,395.9c.06.2-1,.7-2.45.86s-2.61-.09-2.59-.29,1.14-.29,2.5-.45S61.69,395.7,61.75,395.9Z",
    fill: "#263238",
    style: {
      transformOrigin: "59.2311px 396.309px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M68.76,388.93c.06.19-.8.63-2,.74s-2.08-.14-2.06-.34.92-.29,2-.4S68.7,388.73,68.76,388.93Z",
    fill: "#263238",
    style: {
      transformOrigin: "66.7313px 389.254px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M70.1,383.34c-.07.2-1,.05-2.08-.32s-1.9-.83-1.83-1,1-.05,2.08.33S70.17,383.15,70.1,383.34Z",
    fill: "#263238",
    style: {
      transformOrigin: "68.145px 382.687px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M72.67,377.69c-.14.15-.78-.27-1.24-1.07s-.5-1.55-.3-1.6.54.53,1,1.23S72.82,377.55,72.67,377.69Z",
    fill: "#263238",
    style: {
      transformOrigin: "71.8657px 376.369px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M69.57,400.82c.05.2-.75.57-1.8.83a6.73,6.73,0,0,1-1.51.22l-.14-.44c.27,0,.44,0,.48.05s-.08.21-.3.38l-.15-.44a7,7,0,0,1,1.45-.5C68.64,400.67,69.52,400.62,69.57,400.82Z",
    fill: "#263238",
    style: {
      transformOrigin: "67.8461px 401.283px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M71,410.73c.07.19-1,.77-2.3,1.3s-2.49.8-2.56.61,1-.78,2.29-1.3S70.94,410.54,71,410.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "68.57px 411.686px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M63.1,406.33c.07.19-.62.6-1.53.91s-1.7.41-1.77.21.62-.6,1.53-.91S63,406.13,63.1,406.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "61.45px 406.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M63.7,386.17c0,.2-1.24.08-2.61-.41s-2.38-1.15-2.29-1.33,1.2.15,2.54.62S63.75,386,63.7,386.17Z",
    fill: "#263238",
    style: {
      transformOrigin: "61.2481px 385.321px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.86,384c.12.17-.55.81-1.49,1.43s-1.8,1-1.92.81.56-.81,1.5-1.43S82.75,383.8,82.86,384Z",
    fill: "#263238",
    style: {
      transformOrigin: "81.1551px 385.118px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.91,393.92c0,.2-.67.52-1.58.71s-1.68.18-1.73,0,.67-.52,1.58-.71S83.86,393.72,83.91,393.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "82.2538px 394.271px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M85.12,405.11c-.09.18-1.11-.1-2.27-.64s-2-1.13-2-1.32,1.11.1,2.27.64S85.2,404.92,85.12,405.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "82.9874px 404.128px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82.55,416c-.16.14-.82-.4-1.47-1.2s-1-1.55-.89-1.68.81.41,1.47,1.21S82.71,415.86,82.55,416Z",
    fill: "#263238",
    style: {
      transformOrigin: "81.3779px 414.561px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M82,376.65c.13.16-.31.71-1.06,1.08s-1.44.4-1.49.2.49-.52,1.16-.86S81.9,376.49,82,376.65Z",
    fill: "#263238",
    style: {
      transformOrigin: "80.7347px 377.326px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M91.42,386.68c.07.19-.8.67-2,.84s-2.15-.06-2.14-.26.93-.33,2-.48S91.35,386.49,91.42,386.68Z",
    fill: "#263238",
    style: {
      transformOrigin: "89.3519px 387.084px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M89.55,377.68c.09.18-.77.8-2,1.19s-2.28.39-2.31.19.92-.53,2.08-.91S89.45,377.49,89.55,377.68Z",
    fill: "#263238",
    style: {
      transformOrigin: "87.3979px 378.406px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.47,400.63c0,.2-1.48.33-3.26,0s-3.11-1-3-1.15,1.47.11,3.18.41S93.47,400.42,93.47,400.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "90.3368px 400.134px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M90,413.71c-.12.16-1.21-.48-2.29-1.57S86,410,86.13,409.84s1,.72,2.09,1.78S90.11,413.55,90,413.71Z",
    fill: "#263238",
    style: {
      transformOrigin: "88.0616px 411.778px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M74.64,367a34,34,0,0,0-6.55,5.18,32,32,0,0,0-8.16,18,40.8,40.8,0,0,0,.49,11.05,87.57,87.57,0,0,0,2.07,8.87c.72,2.49,1.38,4.49,1.82,5.88a14.64,14.64,0,0,1,.63,2.18,11.76,11.76,0,0,1-.9-2.08c-.53-1.36-1.27-3.34-2.05-5.83a73.65,73.65,0,0,1-2.24-8.9,39.34,39.34,0,0,1-.56-11.25,31.47,31.47,0,0,1,8.52-18.32A23.15,23.15,0,0,1,72.59,368a12.42,12.42,0,0,1,1.5-.78A2.2,2.2,0,0,1,74.64,367Z",
    fill: "#263238",
    style: {
      transformOrigin: "66.8283px 392.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M84.83,418.7c-.17-.09,1.67-2.92,3.35-8a45.39,45.39,0,0,0,2-20.63A38.85,38.85,0,0,0,87,379a26.22,26.22,0,0,0-5.42-7.56,20.12,20.12,0,0,0-5.32-3.36c-1.38-.57-2.21-.71-2.2-.77a2,2,0,0,1,.61,0,10.61,10.61,0,0,1,1.69.45,18.36,18.36,0,0,1,5.56,3.24,25.49,25.49,0,0,1,5.7,7.65,38.19,38.19,0,0,1,3.3,11.2,43.88,43.88,0,0,1-2.25,20.91c-.42,1.29-1,2.39-1.37,3.39s-.88,1.8-1.24,2.46A16,16,0,0,1,84.83,418.7Z",
    fill: "#263238",
    style: {
      transformOrigin: "82.689px 392.993px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "55.89 416.93 97.07 416.93 97.32 425.17 55.89 425.17",
    fill: "#ff725e",
    style: {
      transformOrigin: "76.605px 421.05px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "59.39 421.05 61.75 446.21 91.86 446.21 94.28 421.33",
    fill: "#ff725e",
    style: {
      transformOrigin: "76.835px 433.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M97.32,425.27c0,.21-9.27.37-20.71.37s-20.71-.16-20.71-.37,9.27-.37,20.71-.37S97.32,425.06,97.32,425.27Z",
    fill: "#263238",
    style: {
      transformOrigin: "76.61px 425.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M93.14,432.93a6.2,6.2,0,0,1-.88,1.58,23.14,23.14,0,0,1-3.2,3.77l-.19.18-.18-.2a59.2,59.2,0,0,0-8.08-7.06l.46,0-3.58,3.14L73.26,438l-.23.21-.24-.2-6.87-5.78.4-.05c-1.42,1.74-2.62,3.19-3.56,4.35a9.52,9.52,0,0,1-1.4,1.52,11.21,11.21,0,0,1,1.15-1.72l3.36-4.49.18-.23.23.18,7,5.66h-.46l4.21-3.7,3.59-3.13.22-.19.24.17a52.91,52.91,0,0,1,8,7.29H88.7A40.28,40.28,0,0,0,93.14,432.93Z",
    fill: "#263238",
    style: {
      transformOrigin: "77.25px 434.445px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-active",
    style: {
      transformOrigin: "374.145px 289.06px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 137.46,
    y: 131.77,
    width: 465.06,
    height: 307.54,
    rx: 14.57,
    fill: "#455a64",
    style: {
      transformOrigin: "369.99px 285.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m122.24 419.44h503.85v9.11a17.8 17.8 0 0 1-17.8 17.8h-468.29a17.8 17.8 0 0 1-17.8-17.8v-9.11a0 0 0 0 1 0.04 0z",
    fill: "#455a64",
    style: {
      transformOrigin: "374.145px 432.895px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "324.15 416.56 330.4 426.51 418.38 426.51 424.18 416.56",
    fill: "#263238",
    style: {
      transformOrigin: "374.165px 421.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M598.52,416.56c0,.17-103.22.3-230.51.3s-230.55-.13-230.55-.3,103.2-.3,230.55-.3S598.52,416.39,598.52,416.56Z",
    fill: "#263238",
    style: {
      transformOrigin: "367.99px 416.56px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 150.78,
    y: 149.45,
    width: 436.6,
    height: 258.98,
    rx: 3.27,
    fill: "#ebebeb",
    style: {
      transformOrigin: "369.08px 278.94px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "586.91 408.81 150.31 408.81 150.78 168.81 586.91 168.81",
    fill: "#fff",
    style: {
      transformOrigin: "368.61px 288.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m186.59 159.46a3.49 3.49 0 1 1-3.49-3.46 3.48 3.48 0 0 1 3.49 3.46z",
    fill: "#263238",
    style: {
      transformOrigin: "183.1px 159.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m165.46 159.46a3.49 3.49 0 1 1-3.46-3.46 3.48 3.48 0 0 1 3.46 3.46z",
    fill: "#263238",
    style: {
      transformOrigin: "161.97px 159.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m175.6 159.46a3.49 3.49 0 1 1-3.49-3.49 3.48 3.48 0 0 1 3.49 3.49z",
    fill: "#263238",
    style: {
      transformOrigin: "172.11px 159.46px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 150.31,
    y: 385.63,
    width: 437.07,
    height: 23.18,
    fill: "#263238",
    style: {
      transformOrigin: "368.845px 397.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.83,399.9v.74h-3.48v-.58l1.87-1.78c.46-.44.54-.72.54-1,0-.43-.3-.68-.88-.68a1.32,1.32,0,0,0-1.1.49l-.62-.47a2.2,2.2,0,0,1,1.8-.78c1,0,1.69.51,1.69,1.35a1.88,1.88,0,0,1-.79,1.49l-1.26,1.2Z",
    fill: "#fff",
    style: {
      transformOrigin: "164.995px 398.238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M167.3,397.56a.56.56,0,1,1,.55.56A.54.54,0,0,1,167.3,397.56Zm0,2.57a.56.56,0,1,1,1.11,0,.56.56,0,1,1-1.11,0Z",
    fill: "#fff",
    style: {
      transformOrigin: "167.857px 398.882px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M170.6,395.92v4.72h-.87v-4h-1v-.74Z",
    fill: "#fff",
    style: {
      transformOrigin: "169.665px 398.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M175.75,399.57h-.84v1.07h-.85v-1.07h-2.59V399l2.33-3h.94l-2.2,2.91h1.55v-.95h.82v.95h.84Z",
    fill: "#fff",
    style: {
      transformOrigin: "173.61px 398.32px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 183.46,
    y: 397.68,
    width: 358.24,
    height: 1.63,
    fill: "#fff",
    style: {
      transformOrigin: "362.58px 398.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 183.19,
    y: 395.93,
    width: 111.95,
    height: 4.36,
    fill: "#ff725e",
    style: {
      transformOrigin: "239.165px 398.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m298.76 398.5a5.45 5.45 0 1 1-5.45-5.45 5.45 5.45 0 0 1 5.45 5.45z",
    fill: "#ff725e",
    style: {
      transformOrigin: "293.31px 398.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M550.72,398.45A1.57,1.57,0,0,1,549,400c-1.29,0-2-.83-2-2.35a2.24,2.24,0,0,1,2.32-2.51,2.4,2.4,0,0,1,1.24.31l-.33.66a1.56,1.56,0,0,0-.89-.23c-.89,0-1.45.55-1.45,1.62h0a1.6,1.6,0,0,1,1.26-.49A1.47,1.47,0,0,1,550.72,398.45Zm-.85,0c0-.49-.37-.8-.94-.8a.86.86,0,0,0-1,.81c0,.44.35.79,1,.79A.81.81,0,0,0,549.87,398.49Z",
    fill: "#fff",
    style: {
      transformOrigin: "548.852px 397.573px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M551.15,396.83a.56.56,0,1,1,1.11,0,.56.56,0,1,1-1.11,0Zm0,2.57a.56.56,0,1,1,1.11,0,.56.56,0,1,1-1.11,0Z",
    fill: "#fff",
    style: {
      transformOrigin: "551.705px 398.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m552.82 397.55c0-1.55 0.85-2.43 2-2.43s2 0.88 2 2.43-0.85 2.43-2 2.43-2-0.88-2-2.43zm3.06 0c0-1.14-0.44-1.66-1.09-1.66s-1.09 0.52-1.09 1.66 0.45 1.67 1.09 1.67 1.09-0.53 1.09-1.67z",
    fill: "#fff",
    style: {
      transformOrigin: "554.82px 397.55px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m557.35 397.55c0-1.55 0.85-2.43 2-2.43s2 0.88 2 2.43-0.85 2.43-2 2.43-2-0.88-2-2.43zm3.07 0c0-1.14-0.45-1.66-1.1-1.66s-1.08 0.52-1.08 1.66 0.44 1.67 1.08 1.67 1.1-0.53 1.1-1.67z",
    fill: "#fff",
    style: {
      transformOrigin: "559.35px 397.55px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "568.93 397.26 567.29 397.26 567.29 392.55 572 392.55 572 394.18 568.93 394.18",
    fill: "#fff",
    style: {
      transformOrigin: "569.645px 394.905px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "572 403.4 567.29 403.4 567.29 398.7 568.92 398.7 568.92 401.77 572 401.77",
    fill: "#fff",
    style: {
      transformOrigin: "569.645px 401.05px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "579.5 403.4 574.8 403.4 574.8 401.77 577.86 401.77 577.86 398.69 579.5 398.69",
    fill: "#fff",
    style: {
      transformOrigin: "577.15px 401.045px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "579.5 397.25 577.87 397.25 577.87 394.18 574.79 394.18 574.79 392.55 579.5 392.55",
    fill: "#fff",
    style: {
      transformOrigin: "577.145px 394.9px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "210.19 183.08 184.45 183.08 171.59 205.37 184.45 227.65 210.19 227.65 223.05 205.37",
    fill: "#ebebeb",
    style: {
      transformOrigin: "197.32px 205.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M186.55,209.73a22.72,22.72,0,0,1-3.14-4.06,7.77,7.77,0,0,1-1.07-4.94,27.43,27.43,0,0,0,.65-2.93c.1-1.38-.48-2.82,0-4.11.76-2,3.47-2.33,5.12-3.72,1.28-1.09,1.91-2.85,3.32-3.76a6.25,6.25,0,0,1,4.27-.58,15.75,15.75,0,0,0,4.37.38,29.45,29.45,0,0,0,3-.81,4.11,4.11,0,0,1,3,.21,2,2,0,0,1,.82,2.67c1.69-.78,3.83.54,4.29,2.33a5,5,0,0,1-1.89,4.93,11,11,0,0,1-5.1,2.08c-5.17,1-10.77.43-15.22-2.37",
    fill: "#263238",
    style: {
      transformOrigin: "196.778px 197.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m210.41 215.23c-0.17-3.19-1.06-9.73-1.94-15.64a12.34 12.34 0 0 0-13-10.5h-0.64c-6.84 0.86-9.93 7.15-8.88 14l2 24.55h16.7s-0.4-4.31-0.4-4.35 6.52-1.46 6.16-8.06z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "198.087px 208.352px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m204.24 223.21a15.47 15.47 0 0 1-8.77-1.87s2.36 4.61 8.9 3.58z",
    fill: "#eb996e",
    style: {
      transformOrigin: "199.92px 223.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206.34,205.25a.93.93,0,0,1-.84,1,.89.89,0,0,1-1-.78.94.94,0,0,1,.84-1A.89.89,0,0,1,206.34,205.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "205.42px 205.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M207.27,202.91c-.11.13-.86-.35-1.88-.28s-1.72.63-1.84.51,0-.28.36-.54a2.62,2.62,0,0,1,1.46-.56,2.46,2.46,0,0,1,1.5.38C207.2,202.64,207.32,202.85,207.27,202.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "205.393px 202.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M196.76,205.94a1,1,0,0,1-.84,1,.91.91,0,0,1-1-.79,1,1,0,0,1,.84-1A.91.91,0,0,1,196.76,205.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "195.84px 206.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M197.31,203.77c-.11.13-.86-.35-1.88-.28s-1.72.62-1.84.51,0-.28.36-.54a2.6,2.6,0,0,1,3-.19C197.24,203.49,197.36,203.71,197.31,203.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "195.433px 203.448px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M201.49,211a6.63,6.63,0,0,1,1.63-.41c.26,0,.5-.11.53-.29a1.32,1.32,0,0,0-.22-.75l-.9-1.92a34.65,34.65,0,0,1-2.07-5,33.69,33.69,0,0,1,2.47,4.87c.3.67.59,1.32.87,1.93a1.59,1.59,0,0,1,.2,1,.68.68,0,0,1-.4.41,2,2,0,0,1-.44.09A6.56,6.56,0,0,1,201.49,211Z",
    fill: "#263238",
    style: {
      transformOrigin: "202.237px 206.827px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M197.3,199.77c-.08.28-1.1.22-2.28.45s-2.12.61-2.3.37.08-.38.45-.68a3.87,3.87,0,0,1,1.67-.71,3.75,3.75,0,0,1,1.81.09C197.1,199.44,197.34,199.64,197.3,199.77Z",
    fill: "#263238",
    style: {
      transformOrigin: "194.983px 199.898px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206.7,200c-.17.24-.88.05-1.72.09s-1.54.26-1.72,0,0-.35.31-.59a2.35,2.35,0,0,1,1.37-.47,2.43,2.43,0,0,1,1.4.37C206.65,199.65,206.77,199.88,206.7,200Z",
    fill: "#263238",
    style: {
      transformOrigin: "204.954px 199.621px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M186.8,208c-.12,0-4.63-1-4.18,3.47s5.33,3,5.32,2.9S186.8,208,186.8,208Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "185.264px 211.292px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M185.94,212.85s-.07.06-.19.13a.79.79,0,0,1-.59.07,1.94,1.94,0,0,1-1.07-1.65,2.5,2.5,0,0,1,.11-1.14.9.9,0,0,1,.53-.67.41.41,0,0,1,.48.17c.08.12.06.22.08.22s.09-.08,0-.27a.51.51,0,0,0-.2-.26.57.57,0,0,0-.45-.07,1.13,1.13,0,0,0-.75.78,2.68,2.68,0,0,0-.14,1.28,2,2,0,0,0,1.33,1.83.86.86,0,0,0,.71-.19C186,213,186,212.85,185.94,212.85Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "184.85px 211.323px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208.14,193.42c-.31,1.79-3.95,3.44-7,3.35-2.78-.08-4.16-1.46-6.17-2.44-1.28-.62-1.28-.62-3-.34-1.4.23-2.13,1.88-2.91,3.07,1.5,3.27.89,7.07.25,10.61a1.76,1.76,0,0,1-.45,1.07,1.44,1.44,0,0,1-1.83-.27,5.62,5.62,0,0,1-1.42-2.86,18.69,18.69,0,0,1-.44-7.33,12.63,12.63,0,0,1,3-6.61,12,12,0,0,1,8.19-3.73,14.75,14.75,0,0,1,8.73,2.47,8.79,8.79,0,0,1,3,3",
    fill: "#263238",
    style: {
      transformOrigin: "196.566px 198.442px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M202.16,213.32l-2.3-1.07a.77.77,0,0,0-.42-.1.63.63,0,0,0-.39.27,2.12,2.12,0,0,0-.26,2.34,1.79,1.79,0,0,0,2.16.79,2.45,2.45,0,0,0,1.27-2.16Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "200.386px 213.903px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M201,215.72s-.48.37-1.35.12a2.14,2.14,0,0,1-1.19-1,2.19,2.19,0,0,1-.15-1.88,2.3,2.3,0,0,1,.56-.84,2.32,2.32,0,0,1,.39-.29.64.64,0,0,1,.6,0c.53.29.88.54,1.23.76.67.45,1.07.76,1,.82s-.5-.13-1.22-.5l-1.23-.64c-.09,0-.08,0-.18,0a1.89,1.89,0,0,0-.28.23,1.74,1.74,0,0,0-.42.66,1.8,1.8,0,0,0,.08,1.46,1.87,1.87,0,0,0,.9.85C200.49,215.79,201,215.63,201,215.72Z",
    fill: "#263238",
    style: {
      transformOrigin: "200.132px 213.841px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M200.29,205.36s0-.41-.24-1.12a4.7,4.7,0,0,0-1.73-2.47,4.48,4.48,0,1,0,0,7.19,4.7,4.7,0,0,0,1.73-2.47c.2-.71.19-1.13.24-1.13s0,.11,0,.31a3.51,3.51,0,0,1-.09.87,4.64,4.64,0,0,1-1.69,2.71,4.9,4.9,0,0,1-4.64.76,4.93,4.93,0,0,1,0-9.29,4.9,4.9,0,0,1,4.64.76,4.64,4.64,0,0,1,1.69,2.71,3.47,3.47,0,0,1,.09.87C200.32,205.26,200.31,205.36,200.29,205.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "195.452px 205.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.52,204.92c-.05,0,0-.4-.24-1.09a4.55,4.55,0,0,0-1.68-2.4,4.36,4.36,0,1,0,0,7,4.55,4.55,0,0,0,1.68-2.4c.2-.69.19-1.1.24-1.1s0,.1,0,.3a3.78,3.78,0,0,1-.08.85,4.56,4.56,0,0,1-1.65,2.64,4.77,4.77,0,0,1-4.53.74,4.81,4.81,0,0,1,0-9.06,4.77,4.77,0,0,1,4.53.74,4.58,4.58,0,0,1,1.65,2.65,3.69,3.69,0,0,1,.08.85C211.55,204.82,211.54,204.92,211.52,204.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "206.805px 204.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M202.36,203.89c-.1.09-.55-.2-1.15-.18s-1,.31-1.14.22.28-.72,1.13-.74S202.49,203.81,202.36,203.89Z",
    fill: "#263238",
    style: {
      transformOrigin: "201.213px 203.568px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M191.17,204.7c.09.11-.79.91-1.95,1.78a6.71,6.71,0,0,1-2.26,1.36c-.09-.11.79-.91,1.95-1.78A6.61,6.61,0,0,1,191.17,204.7Z",
    fill: "#263238",
    style: {
      transformOrigin: "189.065px 206.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M284,205.14c0,.14-11.57.26-25.84.26s-25.84-.12-25.84-.26,11.57-.26,25.84-.26S284,205,284,205.14Z",
    fill: "#263238",
    style: {
      transformOrigin: "258.16px 205.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M260.09,210.55c0,.14-6.14.26-13.72.26s-13.72-.12-13.72-.26,6.14-.27,13.72-.27S260.09,210.4,260.09,210.55Z",
    fill: "#263238",
    style: {
      transformOrigin: "246.37px 210.545px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "364.056px 251.257px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438.79,245.09a39.38,39.38,0,0,1,18.56,24c4.83,17.28,19.6,62.28,19.6,62.28s8.44,9.93,9.34,17.28-.9,25.14-3.62,28.46a7.63,7.63,0,0,1-6.58,2.77l-35.53-3.37-14-93.68Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "456.542px 312.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m321.31 243.46s-25.41 8-31.74 14.9l20.8 96.76-0.37 30.54h120.48c0-1.51 1.08-101.38 1.08-101.38l7.23-39.19-42.79-7.53-8.44-6.64-47.63 2.42-7.24 7.23z",
    fill: "#ff725e",
    style: {
      transformOrigin: "364.18px 308.29px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "321.616px 349.783px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M331,327.41c-.37-.82-.91-1.71-1.79-1.89-1.45-.3-2.42,1.41-2.91,2.81a127.56,127.56,0,0,1-15.82,30.89l-.31,14.86c7-5.91,13.94-12.24,18.42-20.25S334.74,335.77,331,327.41Z",
    style: {
      transformOrigin: "321.616px 349.783px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m289.57 258.36s-8.37 11.41-11.84 18.86-32.28 70-34 76.47-6.2 26.81 6.95 31.53h27.07l27.16-54.93 1.39-63.75z",
    fill: "#ff725e",
    style: {
      transformOrigin: "273.944px 321.79px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M279.46,345.54s-.6-.53-1.85-1.24a21,21,0,0,0-5.68-2.06,27.35,27.35,0,0,0-4.14-.58A16.5,16.5,0,0,0,263,342a17.67,17.67,0,0,0-9.11,5.72,24.84,24.84,0,0,0-5.16,9.59,47.85,47.85,0,0,0-1.62,8.85c-.26,2.56-.35,4.65-.44,6.08,0,.68-.08,1.23-.1,1.66a2.1,2.1,0,0,1-.08.58,4.36,4.36,0,0,1,0-.58c0-.44,0-1,0-1.66,0-1.45.06-3.53.27-6.11a46.17,46.17,0,0,1,1.53-9,24.88,24.88,0,0,1,5.23-9.8,18,18,0,0,1,9.4-5.84,16.35,16.35,0,0,1,4.88-.27,26.33,26.33,0,0,1,4.19.65,19.75,19.75,0,0,1,5.7,2.24,10,10,0,0,1,1.35,1A2.84,2.84,0,0,1,279.46,345.54Z",
    fill: "#263238",
    style: {
      transformOrigin: "262.97px 357.813px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.63,334.6a3.52,3.52,0,0,1,.91-.14,16.18,16.18,0,0,1,2.51,0,20.9,20.9,0,0,1,3.69.55,22,22,0,0,1,8.21,3.92,20.47,20.47,0,0,1,2.75,2.52,16.17,16.17,0,0,1,1.55,2,3.42,3.42,0,0,1,.46.8c-.08.06-.82-1-2.28-2.52a24.55,24.55,0,0,0-2.77-2.39,25,25,0,0,0-3.84-2.3,26.36,26.36,0,0,0-4.2-1.54,24,24,0,0,0-3.6-.64C267.94,334.59,266.63,334.7,266.63,334.6Z",
    fill: "#263238",
    style: {
      transformOrigin: "276.67px 339.332px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M291.09,331.59a5.58,5.58,0,0,1-1.25-.09c-.8-.1-1.95-.22-3.39-.33a57.92,57.92,0,0,0-22.13,2.65c-1.37.44-2.47.83-3.22,1.12a6.3,6.3,0,0,1-1.19.39,5,5,0,0,1,1.11-.58c.73-.35,1.82-.79,3.18-1.28a51.08,51.08,0,0,1,22.29-2.66c1.43.15,2.59.32,3.38.49A6.57,6.57,0,0,1,291.09,331.59Z",
    fill: "#263238",
    style: {
      transformOrigin: "275.5px 332.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M368.18,278.14a1.42,1.42,0,0,1-.28-.33l-.74-1-2.72-3.76c-2.33-3.3-5.59-7.9-9.42-13.3l.42-.06c-1.46,4.28-3.07,9-4.76,14l-.11.31-.28-.18-.56-.36a28.82,28.82,0,0,1-5.89-5,35.06,35.06,0,0,1-4.21-5.82A49.07,49.07,0,0,1,335,251.47a78,78,0,0,1-1.75-8c-.16-.9-.28-1.63-.38-2.18a3.47,3.47,0,0,0-.13-.55c0-.12-.07-.18-.06-.19s.41,1,.77,2.89.93,4.61,1.91,7.9a49.39,49.39,0,0,0,4.69,11.06,35.7,35.7,0,0,0,4.17,5.72A28.37,28.37,0,0,0,350,273l.55.36-.38.14c1.71-5,3.33-9.69,4.81-14l.15-.44.27.38c3.76,5.45,7,10.09,9.27,13.41,1.09,1.62,2,2.91,2.61,3.85l.67,1A2.36,2.36,0,0,1,368.18,278.14Z",
    fill: "#263238",
    style: {
      transformOrigin: "350.43px 259.345px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "415.021px 352.105px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M399.53,324.33a54.82,54.82,0,0,0,7,32.46c5.6,9.74,13.82,18.43,24.05,23.09.33-9.93-.15-21.63.18-31.56Z",
    style: {
      transformOrigin: "415.021px 352.105px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M398.4,311.26s-4.38,1.21-1.1,10.18,4.38,8.42,6.57,16.8,4.74,16,8.56,20.78,18.05,14.4,18.05,14.4l12.76-12s-2.1-9-1.6-15.06,1.78-21,1.6-23.59-2.92-8.75-2.92-8.75v-4.24l-6.56-20.18s-3.65-1.64-4.92,4.19l-2.19-6.19s-3.46-.55-4.37,6.56.73,16.95.73,16.95l-1.83,12.39-2.73,8.39-2.37.36s-3.57-1-5.52-7.69S403.32,309.8,398.4,311.26Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "419.669px 330.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M439,343s0-.15-.06-.45-.06-.79-.09-1.34c-.07-1.22-.16-2.91-.27-5-.2-4.35-.47-10.41-.79-17.48l.05.15a2.57,2.57,0,0,0-2.58-.68,3.79,3.79,0,0,0-2.36,1.74c-1.12,1.79-1.18,4.13-1.53,6.38-.69,5.11-1.35,10-1.95,14.41-.3,2.22-.62,4.32-1.05,6.27a39.62,39.62,0,0,1-1.59,5.32c-.56,1.59-1.06,3-1.37,4.33A13.47,13.47,0,0,0,425,360a10.65,10.65,0,0,0,.5,2.86,4.42,4.42,0,0,1-.3-.7,7.53,7.53,0,0,1-.4-2.15,12.75,12.75,0,0,1,.33-3.45,39,39,0,0,1,1.31-4.38,40.84,40.84,0,0,0,1.5-5.29c.41-1.93.72-4,1-6.24.58-4.44,1.23-9.3,1.91-14.42.16-1.13.28-2.26.48-3.38a8.91,8.91,0,0,1,1.12-3.21,4.3,4.3,0,0,1,2.69-1.94,3,3,0,0,1,3.07.84l.05.07v.08c.25,7.07.46,13.13.61,17.49,0,2.11.09,3.8.13,5,0,.55,0,1,0,1.34A2.26,2.26,0,0,1,439,343Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "431.901px 340.216px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432,320a5,5,0,0,1-.54-1.14,30.39,30.39,0,0,1-1.07-3.26,33.64,33.64,0,0,1-.91-5,14.54,14.54,0,0,1-.06-3,6.53,6.53,0,0,1,1.1-3.12,4.48,4.48,0,0,1,2.34-1.76l.19-.05.1.17c1.85,3.26,3.46,6.14,4.58,8.21l1.31,2.45a3.9,3.9,0,0,1,.42.92,4.54,4.54,0,0,1-.58-.83l-1.44-2.37c-1.2-2-2.87-4.87-4.73-8.12l.29.12a4,4,0,0,0-2.05,1.56,6,6,0,0,0-1,2.88,14.41,14.41,0,0,0,0,2.94,37.55,37.55,0,0,0,.79,5c.32,1.4.67,2.52.9,3.29A5.88,5.88,0,0,1,432,320Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "434.415px 311.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.94,321.64a4.68,4.68,0,0,1-.12-1.17c0-.86-.08-1.92-.13-3.17-.08-2.68-.17-6.38-.22-10.47a90.59,90.59,0,0,1,.16-10.49,16.49,16.49,0,0,1,.68-3.12,3.64,3.64,0,0,1,.47-1.08,29.3,29.3,0,0,0-.79,4.24c-.25,2.65,0,6.35,0,10.44s.08,7.79.07,10.47q0,1.89,0,3.18A5.37,5.37,0,0,1,428.94,321.64Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "429.084px 306.89px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M418.15,355.25c-.07-.06.73-1,1.71-2.71a22.76,22.76,0,0,0,1.49-3.11,25.65,25.65,0,0,0,1.14-4.06,25.21,25.21,0,0,0,.35-4.2,23.28,23.28,0,0,0-.3-3.43c-.33-1.95-.75-3.11-.66-3.14a3,3,0,0,1,.36.79,14.42,14.42,0,0,1,.66,2.28,19.5,19.5,0,0,1,.42,3.49,20.65,20.65,0,0,1-1.53,8.45,19.53,19.53,0,0,1-1.61,3.12,14.34,14.34,0,0,1-1.41,1.9C418.4,355.05,418.18,355.27,418.15,355.25Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "420.738px 344.926px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m440.55 349 11.07 3.84s10.58-5.47 17.87 0 13.62 19.88 11.62 25.71c0 0-5 6.22-8.86 7.13s-18.71-2.7-24.9-4-16.87-8.24-16.87-8.24z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "455.982px 367.413px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M441.91,365.29a4.44,4.44,0,0,1-.12-1c0-.75-.09-1.64-.15-2.68-.12-2.26-.27-5.38-.32-8.84s.05-6.59.25-8.85c.1-1.13.23-2,.34-2.67a3.33,3.33,0,0,1,.23-1c.08,0-.09,1.4-.2,3.66s-.15,5.37-.1,8.82.12,6.43.16,8.83c0,1.13,0,2.05,0,2.68A3.28,3.28,0,0,1,441.91,365.29Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "441.734px 352.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m478.42 352.38a35.28 35.28 0 0 0-3.68-3.32 20.27 20.27 0 0 0-22.44-1.23 36.14 36.14 0 0 0-4 2.89 5.92 5.92 0 0 1 0.91-1 18.35 18.35 0 0 1 2.93-2.22 19.91 19.91 0 0 1 22.86 1.27 17.56 17.56 0 0 1 2.66 2.53 5.64 5.64 0 0 1 0.76 1.08z",
    fill: "#263238",
    style: {
      transformOrigin: "463.36px 348.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M477,343.15a22.11,22.11,0,0,0-4.61-2.54,20.34,20.34,0,0,0-12.46-.37,29.12,29.12,0,0,0-6.45,2.68,30.59,30.59,0,0,0-4.67,3.3c-1.24,1.06-2.19,2-2.84,2.63a8,8,0,0,1-1.05,1,6.89,6.89,0,0,1,.9-1.12,34.57,34.57,0,0,1,2.75-2.77,28.73,28.73,0,0,1,4.67-3.43,27.7,27.7,0,0,1,6.55-2.77,19.92,19.92,0,0,1,12.74.53,14.78,14.78,0,0,1,3.41,1.92c.37.27.62.53.81.69S477,343.14,477,343.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "460.96px 344.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M477.09,335.15c0,.1-2-.49-5.18-.92a40.65,40.65,0,0,0-5.67-.36,44.52,44.52,0,0,0-6.93.62,45.36,45.36,0,0,0-6.73,1.78,39.92,39.92,0,0,0-5.21,2.28c-2.87,1.5-4.49,2.72-4.55,2.63a7.09,7.09,0,0,1,1.11-.88,12.71,12.71,0,0,1,1.37-.94c.55-.35,1.17-.76,1.89-1.14a38.38,38.38,0,0,1,5.23-2.4,41.18,41.18,0,0,1,6.8-1.84,42.07,42.07,0,0,1,7-.59,37.45,37.45,0,0,1,5.73.47c.81.1,1.53.29,2.16.42a15.49,15.49,0,0,1,1.62.42A8.26,8.26,0,0,1,477.09,335.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "459.955px 337.287px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.26,237.23a9.19,9.19,0,0,1,.76,2.94,28.3,28.3,0,0,1-.42,8.59,49.24,49.24,0,0,1-1.43,6,45.56,45.56,0,0,1-2.9,6.65c-2.39,4.6-5.39,9.61-8.87,15l-.4.63v-.75c0-3.54,0-7.25,0-11.1l.39.19L370,272.87l.08-.12A98.24,98.24,0,0,0,366,295.2c-.92,12.17-.18,23.81.39,34.37s.82,20.09,1.15,28.09.6,14.46.84,18.93c.14,2.22.24,3.94.31,5.14,0,.57.07,1,.09,1.34s0,.46,0,.46,0-.15-.07-.45-.08-.77-.14-1.34c-.11-1.17-.25-2.9-.4-5.14-.3-4.46-.65-10.93-1-18.93s-.78-17.51-1.26-28.08-1.35-22.22-.43-34.43a97.78,97.78,0,0,1,4.19-22.57l0-.07.06,0,9.36-7.51.39-.32v.5c0,3.85,0,7.56,0,11.1l-.41-.13c6.87-10.65,12.46-19.91,13.32-27.4a29.37,29.37,0,0,0,.54-8.52,15.26,15.26,0,0,0-.41-2.22C392.32,237.48,392.26,237.23,392.26,237.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "379.124px 310.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374.32,366.22H374a2.81,2.81,0,1,0,.36,0Z",
    fill: "#fff",
    style: {
      transformOrigin: "374.18px 369.027px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374.32,327.68H374a2.8,2.8,0,1,0,.36,0Z",
    fill: "#fff",
    style: {
      transformOrigin: "374.18px 330.477px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374,293.2a2.82,2.82,0,0,0,.37-5.63H374a2.82,2.82,0,0,0,0,5.64Z",
    fill: "#fff",
    style: {
      transformOrigin: "374.093px 290.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M330.77,192.07c-3.5-3.89-7-7.81-9.59-12.37s-4.08-9.89-3.24-15c.5-3,1.78-5.9,2-9,.28-4.2-1.48-8.59,0-12.52,2.32-6.16,10.61-7.11,15.63-11.36,3.91-3.31,5.81-8.68,10.11-11.46,3.76-2.44,8.59-2.38,13-1.76s8.89,1.75,13.33,1.15c3.16-.42,6.14-1.7,9.23-2.47s6.56-1,9.31.64,4.31,5.51,2.5,8.14c5.14-2.37,11.67,1.64,13.08,7.12s-1.41,11.41-5.77,15-10,5.3-15.55,6.35c-15.74,3-32.83,1.29-46.4-7.23",
    fill: "#263238",
    style: {
      transformOrigin: "362.101px 154.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M386.14,245c-.77-6-1.4-10.93-1.44-11.55,0,0,19.92-4.48,18.82-24.62-.53-9.74-3.25-29.7-5.93-47.73a37.56,37.56,0,0,0-39.68-32l-2,.12c-20.85,2.63-30.28,21.81-27.08,42.59l11.26,69.67s4.8,15.41,15.07,18.08l13,18.52,2.14-8,9.66-8.42a38.06,38.06,0,0,0,4.77-7.09A15.56,15.56,0,0,0,386.14,245Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "365.892px 203.548px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m384.71 233.17s-12.65 1.88-26.74-5.71c0 0 7.18 14.07 27.14 10.92z",
    fill: "#eb996e",
    style: {
      transformOrigin: "371.54px 233.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m391.12 178.42a2.89 2.89 0 0 1-2.58 3.09 2.75 2.75 0 0 1-3.13-2.4 2.87 2.87 0 0 1 2.59-3.11 2.75 2.75 0 0 1 3.12 2.42z",
    fill: "#263238",
    style: {
      transformOrigin: "388.263px 178.756px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m393.93 171.28c-0.33 0.4-2.62-1.07-5.71-0.85s-5.22 1.91-5.62 1.57c-0.17-0.15 0.15-0.85 1.09-1.64a7.87 7.87 0 0 1 4.46-1.71 7.54 7.54 0 0 1 4.58 1.15c1 0.64 1.36 1.3 1.2 1.48z",
    fill: "#263238",
    style: {
      transformOrigin: "388.261px 170.338px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m361.9 180.51a2.87 2.87 0 0 1-2.58 3.08 2.74 2.74 0 0 1-3.13-2.39 2.89 2.89 0 0 1 2.57-3.09 2.76 2.76 0 0 1 3.14 2.4z",
    fill: "#263238",
    style: {
      transformOrigin: "359.045px 180.851px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m363.57 173.89c-0.34 0.4-2.62-1.07-5.71-0.85s-5.26 1.91-5.62 1.55c-0.18-0.15 0.14-0.85 1.08-1.64a7.93 7.93 0 0 1 4.47-1.71 7.53 7.53 0 0 1 4.57 1.15c1 0.66 1.37 1.32 1.21 1.5z",
    fill: "#263238",
    style: {
      transformOrigin: "357.899px 172.93px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m376.32 196.08c0-0.18 1.88-0.64 5-1.25 0.78-0.13 1.52-0.34 1.62-0.88a4.05 4.05 0 0 0-0.69-2.31l-2.74-5.86c-3.81-8.34-6.63-15.23-6.29-15.38s3.7 6.49 7.52 14.84l2.64 5.9a4.6 4.6 0 0 1 0.62 3.07 2 2 0 0 1-1.22 1.24 5.38 5.38 0 0 1-1.33 0.28c-3.16 0.38-5.1 0.52-5.13 0.35z",
    fill: "#263238",
    style: {
      transformOrigin: "378.621px 183.274px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m363.55 161.71c-0.25 0.87-3.36 0.67-7 1.35s-6.47 1.87-7 1.15c-0.24-0.35 0.22-1.17 1.35-2.07a12.39 12.39 0 0 1 10.63-1.9c1.41 0.45 2.13 1.07 2.02 1.47z",
    fill: "#263238",
    style: {
      transformOrigin: "356.525px 162.106px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M392.19,162.4c-.49.74-2.67.16-5.24.29s-4.7.79-5.25.09c-.24-.34.06-1.07,1-1.8a7.62,7.62,0,0,1,8.45-.3C392.07,161.34,392.41,162,392.19,162.4Z",
    fill: "#263238",
    style: {
      transformOrigin: "386.938px 161.321px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m331.52 186.66c-0.35-0.12-14.1-3.16-12.74 10.57s16.22 9.25 16.22 8.86-3.48-19.43-3.48-19.43z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "326.843px 196.694px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M328.92,201.58c-.07,0-.22.19-.61.41a2.38,2.38,0,0,1-1.78.22c-1.51-.39-3-2.57-3.27-5a8,8,0,0,1,.33-3.49,2.79,2.79,0,0,1,1.62-2,1.23,1.23,0,0,1,1.48.52c.22.37.16.65.23.66s.27-.25.11-.81a1.56,1.56,0,0,0-.63-.81A1.86,1.86,0,0,0,325,191a3.38,3.38,0,0,0-2.28,2.38,8.11,8.11,0,0,0-.45,3.91c.36,2.76,2,5.21,4.07,5.58a2.57,2.57,0,0,0,2.16-.58C328.93,201.91,329,201.6,328.92,201.58Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "325.575px 196.94px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.58,142.35c-.94,5.47-12,10.48-21.22,10.21-8.47-.25-12.66-4.45-18.81-7.44-3.9-1.89-3.9-1.89-9.19-1-4.27.69-6.49,5.74-8.89,9.34,4.57,10,2.72,21.56.78,32.36a5.46,5.46,0,0,1-1.39,3.28c-1.54,1.36-4,.55-5.56-.84-2.43-2.23-3.54-5.53-4.33-8.73a56.48,56.48,0,0,1-1.36-22.33A38.7,38.7,0,0,1,335.89,137a36.66,36.66,0,0,1,25-11.39,45,45,0,0,1,26.62,7.56c3.64,2.39,7,5.34,9.1,9.17",
    fill: "#263238",
    style: {
      transformOrigin: "361.339px 157.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M378.35,203l-7-3.26a2.31,2.31,0,0,0-1.27-.32,2,2,0,0,0-1.21.82,6.49,6.49,0,0,0-.78,7.15,5.48,5.48,0,0,0,6.57,2.42c2.48-1,3.68-3.91,3.88-6.59Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "372.95px 204.771px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M374.88,210.33c0,.06-.33.26-1,.41a6.06,6.06,0,0,1-3-.22,6.25,6.25,0,0,1-3.47-2.89,6.43,6.43,0,0,1-.43-5.52,6.69,6.69,0,0,1,1.62-2.45,6.43,6.43,0,0,1,1.14-.86,1.8,1.8,0,0,1,.81-.25,1.86,1.86,0,0,1,.81.15,12.45,12.45,0,0,1,1.09.62l.95.59,1.71,1.06c2.07,1.32,3.32,2.2,3.25,2.32s-1.45-.52-3.62-1.68l-1.77-1-1-.55c-.34-.17-.7-.4-1-.52a.74.74,0,0,0-.77.08,5.45,5.45,0,0,0-.92.73,6,6,0,0,0-1.36,2.08,5.64,5.64,0,0,0,.3,4.69,5.78,5.78,0,0,0,2.89,2.66,7.05,7.05,0,0,0,2.71.51C374.48,210.32,374.85,210.26,374.88,210.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "372.457px 204.692px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m372.67 178.77a24.45 24.45 0 0 0-0.55-3.48 14.18 14.18 0 0 0-18.59-9.77 13.48 13.48 0 0 0-3.57 1.93 13 13 0 0 0-3 3 14 14 0 0 0 0 16.65 13 13 0 0 0 3 3 13.48 13.48 0 0 0 3.57 1.93 14.22 14.22 0 0 0 18.59-9.77 24.69 24.69 0 0 0 0.55-3.47 0.77 0.77 0 0 1 0 0.23v0.68a5.82 5.82 0 0 1-0.08 1.11 11.18 11.18 0 0 1-0.27 1.5 13.73 13.73 0 0 1-1.55 3.87 14.47 14.47 0 0 1-17.41 6.3 13.75 13.75 0 0 1-3.69-2 13.56 13.56 0 0 1-3.1-3.09 14.5 14.5 0 0 1 0-17.25 13.33 13.33 0 0 1 3.09-3.09 13.75 13.75 0 0 1 3.69-2 14.57 14.57 0 0 1 7.65-0.6 14.45 14.45 0 0 1 9.76 6.9 13.73 13.73 0 0 1 1.55 3.87 11.18 11.18 0 0 1 0.27 1.5 5.82 5.82 0 0 1 0.08 1.11v0.68a0.87 0.87 0 0 1 0.01 0.26z",
    fill: "#263238",
    style: {
      transformOrigin: "358.202px 178.768px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M406.91,177.42a24.72,24.72,0,0,0-.53-3.39,13.93,13.93,0,0,0-5.1-7.57,13.55,13.55,0,0,0-5.8-2.55,13.79,13.79,0,0,0-7.22.61,13.44,13.44,0,0,0-3.47,1.87,13.17,13.17,0,0,0-2.9,2.92,13.69,13.69,0,0,0,0,16.22,12.92,12.92,0,0,0,2.9,2.91,13.18,13.18,0,0,0,3.47,1.88,13.89,13.89,0,0,0,7.22.61,13.55,13.55,0,0,0,5.8-2.55,13.93,13.93,0,0,0,5.1-7.57,24.72,24.72,0,0,0,.53-3.39,5.52,5.52,0,0,1,0,.89,6.56,6.56,0,0,1-.08,1.09,10.81,10.81,0,0,1-.26,1.46,14.09,14.09,0,0,1-11,10.5,14.26,14.26,0,0,1-7.46-.59,14.36,14.36,0,0,1-6.62-4.94,14.15,14.15,0,0,1,0-16.82,14.36,14.36,0,0,1,6.62-4.94,14.26,14.26,0,0,1,7.46-.59,14.09,14.09,0,0,1,11,10.5,10.81,10.81,0,0,1,.26,1.46,6.56,6.56,0,0,1,.08,1.09A5.52,5.52,0,0,1,406.91,177.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "392.824px 177.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M379,174.26c-.06.05-.39-.22-1-.51a5.67,5.67,0,0,0-2.52-.55,5.47,5.47,0,0,0-2.49.64c-.6.31-.92.6-1,.54s.18-.44.78-.86a4.9,4.9,0,0,1,5.38-.09C378.76,173.83,379,174.22,379,174.26Z",
    fill: "#263238",
    style: {
      transformOrigin: "375.488px 173.529px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m344.85 176.73a63.22 63.22 0 0 1-6.26 5 64 64 0 0 1-6.58 4.59 60.28 60.28 0 0 1 6.27-5 62.16 62.16 0 0 1 6.57-4.59z",
    fill: "#263238",
    style: {
      transformOrigin: "338.43px 181.525px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "344.228px 260.384px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M333,241.81c-1.39,13.57,3.77,27.9,14.66,36.12.85.65,1.92,1.29,2.93.92a3.2,3.2,0,0,0,1.52-1.56,26.52,26.52,0,0,0,3.24-17.44c-1.72,4.54-3.2,9-4.94,13.74C340.94,267.83,335,255.59,333,241.81Z",
    style: {
      transformOrigin: "344.228px 260.384px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m369.87 272.67 8-2.92 1.32 13.51s8.62-15.71 12.19-22.87 1.73-19.82 1.73-19.82 1.27 11-7.36 25.07l-6.52 10.6v-11.1z",
    opacity: 0.3,
    style: {
      transformOrigin: "381.727px 261.915px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "266.323px 347.397px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m277 341.33a21.32 21.32 0 0 0-11.57-1.45 22.27 22.27 0 0 0-11.52 4.36c-3.24 2.61-5.43 6.73-5 10.87l0.4 0.05c2.79-7.54 8.33-13 15.48-13.69s14.12 2.51 19 7.76c-0.53-3.92-3.27-6.23-6.79-7.9z",
    style: {
      transformOrigin: "266.323px 347.397px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "465.969px 351.616px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m478.94 349a18.27 18.27 0 0 0-10.32-5.31 23.14 23.14 0 0 0-19.24 5.57l1.52-1.24a24.29 24.29 0 0 1 12.82-3.48 18.51 18.51 0 0 1 12.21 4.88c3 2.84 4.79 6.69 6.5 10.44a13.07 13.07 0 0 0-3.49-10.86z",
    style: {
      transformOrigin: "465.969px 351.616px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.45,286.3a5.45,5.45,0,0,1,.36-1.09c.31-.79.69-1.76,1.13-2.91,1-2.45,2.3-5.83,3.7-9.6s2.61-7.2,3.48-9.68l1-2.95a5.22,5.22,0,0,1,.44-1.06,4.15,4.15,0,0,1-.25,1.12c-.19.72-.49,1.74-.88,3-.78,2.52-1.94,6-3.34,9.75s-2.79,7.15-3.85,9.56c-.52,1.21-1,2.18-1.29,2.85A4.59,4.59,0,0,1,427.45,286.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "432.505px 272.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m301.38 287.28c-0.14 0-1.23-4.73-2.43-10.63s-2.06-10.65-1.95-10.73 1.22 4.73 2.42 10.63 2.1 10.7 1.96 10.73z",
    fill: "#263238",
    style: {
      transformOrigin: "299.192px 276.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299.49 346.77c0.32 0.16-3.66-31.16-3.66-31.16s2.51-23.77 3.92-24.87v-8.39s3.89-2.35 4.93 1.45c0 0 3.45-3 4 4.13s0.73 14.41 0.73 14.41l7.67 19.18 1.26 0.64s1.65-15 2.61-17.24 1.62-7.59 5.25-6.78 3.94 3.81 3.29 8.71-1.47 10-1.16 13.14 1.74 10.13 1.3 15.67-3.48 11.38-6.66 15.48-9.27 12.59-12.57 15.14c-1.07 0.9-10.91-19.51-10.91-19.51z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "312.795px 323.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M303.37,321.28a6,6,0,0,1,0-1.34c.06-1,.15-2.18.25-3.64.23-3.07.59-7.31,1-12,.22-2.33.43-4.55.62-6.59a11.74,11.74,0,0,0,0-2.83,4,4,0,0,0-1-2.16,4.28,4.28,0,0,0-3.13-1.37,8.87,8.87,0,0,0-1.31.16,1.22,1.22,0,0,1,.32-.16,3.38,3.38,0,0,1,1-.21,4.4,4.4,0,0,1,3.41,1.33,4.28,4.28,0,0,1,1.11,2.35,11.46,11.46,0,0,1,0,2.93c-.18,2-.38,4.27-.58,6.6-.43,4.68-.85,8.91-1.18,12l-.41,3.63A7.6,7.6,0,0,1,303.37,321.28Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "302.767px 306.206px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m307.49 308.47a10.88 10.88 0 0 0-1.36 2.47 41.44 41.44 0 0 0-1.27 6.76c-0.42 2.68-0.82 5.1-1.14 6.85a15 15 0 0 1-0.62 2.81 16.7 16.7 0 0 1 0.26-2.87c0.22-1.76 0.57-4.19 1-6.87s0.71-5.13 1.45-6.81a6.55 6.55 0 0 1 1.09-1.81c0.33-0.4 0.57-0.55 0.59-0.53z",
    fill: "#eb996e",
    style: {
      transformOrigin: "305.295px 317.914px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M304.67,283.39a3.49,3.49,0,0,1,.27,1c.14.64.31,1.57.5,2.73.38,2.31.8,5.52,1.07,9.09s.32,6.81.28,9.15c0,1.17-.05,2.12-.1,2.77a3.5,3.5,0,0,1-.12,1,33.45,33.45,0,0,1-.15-3.78c-.05-2.34-.17-5.56-.43-9.11s-.62-6.76-.91-9.08A31.93,31.93,0,0,1,304.67,283.39Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "305.736px 296.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m326.8 312.75a2.76 2.76 0 0 1-2.58 0.22c-1.47-0.44-2.15-1.57-2-1.62a13.7 13.7 0 0 0 2.17 1.12 14.61 14.61 0 0 0 2.41 0.28z",
    fill: "#eb996e",
    style: {
      transformOrigin: "324.5px 312.271px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299.92 342.87-20.26 8.52h-12.08s-11.94 3.73-13.78 14.93-2.1 16.95 3.15 18.34 20.08 1.54 27.43-0.9 26.61-18 26.61-18l1.85-11.24z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "282.721px 364.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m304.67 355.25s-0.23-0.17-0.58-0.53a12.88 12.88 0 0 1-1.31-1.68 22.77 22.77 0 0 1-2.83-6.41 38 38 0 0 1-1.25-6.88 13 13 0 0 1-0.08-2.9 19.53 19.53 0 0 1 0.44 2.85 50.94 50.94 0 0 0 1.39 6.79 26.89 26.89 0 0 0 2.64 6.36c0.91 1.51 1.65 2.33 1.58 2.4z",
    fill: "#eb996e",
    style: {
      transformOrigin: "301.624px 346.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M313.5,358.8a21.12,21.12,0,0,0,1.15-4.34,14,14,0,0,0-2.72-10.18c-1.23-1.72-2.62-3.22-3.79-4.68a22.16,22.16,0,0,1-2.74-4.14,10.93,10.93,0,0,1-1-3.2,4.07,4.07,0,0,1,0-1.22,14.3,14.3,0,0,0,1.38,4.25,23.31,23.31,0,0,0,2.79,4c1.17,1.42,2.57,2.92,3.83,4.68a14.56,14.56,0,0,1,2.53,5.55,14.11,14.11,0,0,1,.13,5,13.14,13.14,0,0,1-.92,3.22c-.16.36-.31.63-.41.81S313.51,358.81,313.5,358.8Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "309.789px 344.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m282.25 310a101.59 101.59 0 0 1-4.94-9c-2.6-5-4.6-9.16-4.48-9.23a101.59 101.59 0 0 1 4.94 9 100.34 100.34 0 0 1 4.48 9.23z",
    fill: "#fff",
    style: {
      transformOrigin: "277.537px 300.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m315 273.51a62.15 62.15 0 0 1 3.05-7.5 64.43 64.43 0 0 1 3.53-7.28 64.2 64.2 0 0 1-3.05 7.5 63.39 63.39 0 0 1-3.53 7.28z",
    fill: "#fff",
    style: {
      transformOrigin: "318.29px 266.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m347.13 297.19a46.21 46.21 0 0 1-4.6-5.14 46.71 46.71 0 0 1-4.19-5.47 44.53 44.53 0 0 1 4.59 5.14 46.2 46.2 0 0 1 4.2 5.47z",
    fill: "#fff",
    style: {
      transformOrigin: "342.735px 291.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m339.74 329.76a39.87 39.87 0 0 1 3.46-5.22 38.19 38.19 0 0 1 3.89-4.91 39.12 39.12 0 0 1-3.46 5.22 36.53 36.53 0 0 1-3.89 4.91z",
    fill: "#fff",
    style: {
      transformOrigin: "343.415px 324.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m329.8 375.77a9.93 9.93 0 0 1-1.17-2c-0.66-1.28-1.51-3.07-2.37-5.08s-1.55-3.88-2-5.23a10.1 10.1 0 0 1-0.64-2.24 10.35 10.35 0 0 1 1 2.11l2.15 5.15c0.83 1.91 1.57 3.64 2.22 5.13a10.37 10.37 0 0 1 0.81 2.16z",
    fill: "#fff",
    style: {
      transformOrigin: "326.71px 368.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M358,356.21a37.15,37.15,0,0,1-6.07-.91,36.15,36.15,0,0,1-6-1.42,72.47,72.47,0,0,1,12,2.33Z",
    fill: "#fff",
    style: {
      transformOrigin: "351.965px 355.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m380 313.22a72.88 72.88 0 0 1 5.78-6.62 75 75 0 0 1 6.18-6.28 75.27 75.27 0 0 1-5.79 6.63 76.61 76.61 0 0 1-6.17 6.27z",
    fill: "#fff",
    style: {
      transformOrigin: "385.98px 306.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m402 370.55c-0.11 0.1-3.34-3.65-7.22-8.35s-6.93-8.6-6.82-8.69 3.34 3.65 7.22 8.35 6.91 8.6 6.82 8.69z",
    fill: "#fff",
    style: {
      transformOrigin: "394.98px 362.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m265.2 346.12c0.07 0.14-2.88 1.64-6.1 4.11s-5.46 4.91-5.58 4.8a7.12 7.12 0 0 1 1.36-1.7 30.76 30.76 0 0 1 3.9-3.51 31.22 31.22 0 0 1 4.42-2.82 7.53 7.53 0 0 1 2-0.88z",
    fill: "#fff",
    style: {
      transformOrigin: "259.361px 350.577px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m273.44 324a21.31 21.31 0 0 1-2.35 4 21 21 0 0 1-2.79 3.72 21.55 21.55 0 0 1 2.35-4 20.7 20.7 0 0 1 2.79-3.72z",
    fill: "#fff",
    style: {
      transformOrigin: "270.87px 327.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m292 345.72a13.21 13.21 0 0 1-1.94-8.55c0.15 0 0.2 2 0.75 4.33s1.33 4.15 1.19 4.22z",
    fill: "#fff",
    style: {
      transformOrigin: "290.995px 341.445px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294.75,276.8a15.36,15.36,0,0,1-3.85.81,14.81,14.81,0,0,1-3.93.29,15.51,15.51,0,0,1,3.86-.81A15.25,15.25,0,0,1,294.75,276.8Z",
    fill: "#fff",
    style: {
      transformOrigin: "290.86px 277.352px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m308.69 252.07a30.65 30.65 0 0 1-7 3.88 15.31 15.31 0 0 1 3.37-2.17 15.86 15.86 0 0 1 3.63-1.71z",
    fill: "#fff",
    style: {
      transformOrigin: "305.19px 254.01px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m347.9 262.52a36.37 36.37 0 0 1-3.86-4.64 36 36 0 0 1-3.44-4.95 69.7 69.7 0 0 1 7.3 9.59z",
    fill: "#fff",
    style: {
      transformOrigin: "344.25px 257.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m397.67 287.38a24.49 24.49 0 0 1-6.05-9.72c0.15-0.06 1.22 2.27 2.9 4.94s3.27 4.68 3.15 4.78z",
    fill: "#fff",
    style: {
      transformOrigin: "394.648px 282.519px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m416.67 293.64a58.28 58.28 0 0 1-4.6 10.13 30.94 30.94 0 0 1 2.07-5.17 29.36 29.36 0 0 1 2.53-4.96z",
    fill: "#fff",
    style: {
      transformOrigin: "414.37px 298.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m419.33 267.71a53.74 53.74 0 0 1-5.06-5.66 55.39 55.39 0 0 1-4.65-6 110.86 110.86 0 0 1 9.71 11.66z",
    fill: "#fff",
    style: {
      transformOrigin: "414.475px 261.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m390.31 246.65a23.5 23.5 0 0 1-0.45-4.84 22.78 22.78 0 0 1 0.07-4.87 23.5 23.5 0 0 1 0.45 4.84 22 22 0 0 1-0.07 4.87z",
    fill: "#fff",
    style: {
      transformOrigin: "390.122px 241.795px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M414,245.34a38.41,38.41,0,0,1-6.18,1.09,37.86,37.86,0,0,1-6.24.57,38.41,38.41,0,0,1,6.18-1.09A37.78,37.78,0,0,1,414,245.34Z",
    fill: "#fff",
    style: {
      transformOrigin: "407.79px 246.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m451.23 272.71a63 63 0 0 1-3.72-7.08 61.87 61.87 0 0 1-3.24-7.31 62.06 62.06 0 0 1 3.73 7.08 62.21 62.21 0 0 1 3.23 7.31z",
    fill: "#fff",
    style: {
      transformOrigin: "447.75px 265.515px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m445 296.36a65 65 0 0 1 2.26-11.28 32.44 32.44 0 0 1-0.87 5.69 31.54 31.54 0 0 1-1.39 5.59z",
    fill: "#fff",
    style: {
      transformOrigin: "446.13px 290.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m462.24 315a63.19 63.19 0 0 1-3-7.68 64 64 0 0 1-2.47-7.86 66.07 66.07 0 0 1 3 7.69 65.45 65.45 0 0 1 2.47 7.85z",
    fill: "#fff",
    style: {
      transformOrigin: "459.505px 307.23px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m459.83 325.91a13.86 13.86 0 0 1-5.05-1.81 13.4 13.4 0 0 1-4.27-3.24c0.1-0.12 1.94 1.4 4.52 2.78s4.85 2.12 4.8 2.27z",
    fill: "#fff",
    style: {
      transformOrigin: "455.17px 323.382px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m482 350.77a28.55 28.55 0 0 1-3.11-7 28.55 28.55 0 0 1 3.11 7z",
    fill: "#fff",
    style: {
      transformOrigin: "480.445px 347.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m351.21 385.45a19.92 19.92 0 0 1-0.78-4.43 20.23 20.23 0 0 1-0.26-4.49 18.78 18.78 0 0 1 0.83 4.47 19.53 19.53 0 0 1 0.21 4.45z",
    fill: "#fff",
    style: {
      transformOrigin: "350.697px 380.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m419.14 383.73a18.65 18.65 0 0 1 0.65-4.33 18.91 18.91 0 0 1 1.17-4.22 18.31 18.31 0 0 1-0.66 4.33 18.6 18.6 0 0 1-1.16 4.22z",
    fill: "#fff",
    style: {
      transformOrigin: "420.05px 379.455px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "474.997px 148.285px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m432.16 185.44 8.84-15.44a41.46 41.46 0 1 1 9.93 11z",
    fill: "#fafafa",
    style: {
      transformOrigin: "474.932px 148.166px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M432.16,185.44l18.77-4.28.19,0L451,181h0l-.18.17a42.72,42.72,0,0,0,8.52,5.14,41.46,41.46,0,0,0,11.36,3.24,37.17,37.17,0,0,0,6.56.33c1.13-.06,2.27-.09,3.43-.18l3.5-.53a41.78,41.78,0,0,0,25.89-16.62,41.38,41.38,0,0,0,7-16,42.42,42.42,0,0,0-.49-18.43,40.93,40.93,0,0,0-8.88-17L506,119.17c-.56-.63-1.22-1.14-1.82-1.72s-1.2-1.16-1.88-1.64l-2-1.48a16.67,16.67,0,0,0-2.06-1.36l-2.1-1.28-2.2-1.07a20.88,20.88,0,0,0-2.22-1,42.46,42.46,0,0,0-18.57-2.85,40.8,40.8,0,0,0-17,5A42,42,0,0,0,436.46,136a44.6,44.6,0,0,0-1.8,13.47,41,41,0,0,0,2,11.63,42.29,42.29,0,0,0,4.15,8.92v-.13c-5.54,9.93-8.25,14.78-8.68,15.54.44-.75,3.22-5.57,8.89-15.42l0-.06,0-.06A41.64,41.64,0,0,1,437,161a40.93,40.93,0,0,1-2-11.55,44.76,44.76,0,0,1,1.83-13.34,41.71,41.71,0,0,1,19.51-23.9,40.31,40.31,0,0,1,16.85-5,41.87,41.87,0,0,1,18.34,2.83,20.34,20.34,0,0,1,2.19,1l2.18,1.06L498,113.4a17.37,17.37,0,0,1,2,1.34l2,1.47c.67.48,1.23,1.08,1.85,1.62s1.25,1.08,1.8,1.7l1.67,1.83a40.57,40.57,0,0,1,8.78,16.83,41.68,41.68,0,0,1,.49,18.2,40.75,40.75,0,0,1-6.9,15.83,41.39,41.39,0,0,1-25.58,16.49l-3.46.54c-1.15.09-2.28.13-3.4.19a37.5,37.5,0,0,1-6.5-.3A41.32,41.32,0,0,1,459.45,186a42.34,42.34,0,0,1-8.49-5.06l-.77-.59.59.77,0,0,.07-.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "474.997px 148.285px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m487.4 146.55a4 4 0 1 0 4.05-4.05 4 4 0 0 0-4.05 4.05z",
    fill: "#263238",
    style: {
      transformOrigin: "491.4px 146.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m471.21 146.55a4 4 0 1 0 4-4.05 4 4 0 0 0-4 4.05z",
    fill: "#263238",
    style: {
      transformOrigin: "475.21px 146.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m455.06 144.53a4 4 0 1 0 5.52-1.48 4 4 0 0 0-5.52 1.48z",
    fill: "#263238",
    style: {
      transformOrigin: "458.545px 146.494px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeAnimate);
export default __webpack_public_path__ + "static/media/knowledge-animate.dc5ba1f326b2f32c8100f9df26452ee3.svg";
export { ForwardRef as ReactComponent };